module.exports = __webpack_public_path__ + "static/media/dinner.ea8df982.png";